import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { initAnalytics } from './analytics';
import './index.css';
import App from './App';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    tracesSampleRate: 0.2,
  });
}

initAnalytics();

const root = createRoot(document.getElementById('root'));
root.render(<App />);
